import { SearchOutlined } from "@ant-design/icons";
import {
  Button,
  DatePicker,
  Divider,
  Flex,
  Form,
  Input,
  InputNumber,
  Select,
  Space,
} from "antd";
import React, { useEffect } from "react";
import LockKey from "../../assets/images/icons/LockKey";
import {
  H1,
  H2,
  H3,
  H4,
  H5,
  H6,
  P1,
  P2,
  P3,
} from "../../components/NormalFonts";
import styles from "./styles.module.scss";

const Design: React.FC = () => {
  const { Option } = Select;

  const selectBefore = (
    <Select defaultValue="http://">
      <Option value="http://">http://</Option>
      <Option value="https://">https://</Option>
    </Select>
  );
  const selectAfter = (
    <Select defaultValue=".com">
      <Option value=".com">.com</Option>
      <Option value=".jp">.jp</Option>
      <Option value=".cn">.cn</Option>
      <Option value=".org">.org</Option>
    </Select>
  );

  const { TextArea } = Input;
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue({ error: "" });
  }, []);

  return (
    <div className={styles.container}>
      <Flex gap={"small"} vertical>
        <Space>
          <P1>Basic</P1>
          <Input placeholder="Placeholder" />
          <Input status={"error"} placeholder="Placeholder" />
          <Input disabled placeholder="Placeholder" />
        </Space>
        <Space>
          <P1>Password</P1>
          <Input.Password placeholder="Placeholder" />
          <Input.Password status={"error"} placeholder="Placeholder" />
          <Input.Password disabled placeholder="Placeholder" />
        </Space>
        <Space>
          <P1>Password with icon</P1>
          <Input.Password addonBefore={<LockKey />} placeholder="Placeholder" />
          <Input.Password
            addonBefore={<LockKey />}
            status={"error"}
            placeholder="Placeholder"
          />
          <Input.Password
            addonBefore={<LockKey />}
            disabled
            placeholder="Placeholder"
          />
        </Space>
        <Space>
          <P1>Area</P1>
          <TextArea maxLength={100} showCount placeholder="Placeholder" />
          <TextArea
            maxLength={100}
            showCount
            status={"error"}
            placeholder="Placeholder"
          />
          <TextArea
            maxLength={100}
            showCount
            disabled
            placeholder="Placeholder"
          />
        </Space>
        <br />
        <Space>
          <P1>Prefix / Suffix</P1>
          <Input prefix={"$"} suffix={"RMB"} placeholder="Placeholder" />
          <Input
            prefix={"$"}
            suffix={"RMB"}
            status={"error"}
            placeholder="Placeholder"
          />
          <Input
            prefix={"$"}
            suffix={"RMB"}
            disabled
            placeholder="Placeholder"
          />
        </Space>
        <Space>
          <P1>Prefix / Suffix Icon</P1>
          <Input
            prefix={<LockKey />}
            suffix={<LockKey />}
            placeholder="Placeholder"
          />
          <Input
            prefix={<LockKey />}
            suffix={<LockKey />}
            status={"error"}
            placeholder="Placeholder"
          />
          <Input
            prefix={<LockKey />}
            suffix={<LockKey />}
            disabled
            placeholder="Placeholder"
          />
        </Space>
        <Space>
          <P1>Addon after / before</P1>
          <Input
            addonBefore="http://"
            addonAfter=".com"
            placeholder="Placeholder"
          />
          <Input
            addonBefore="http://"
            addonAfter=".com"
            status={"error"}
            placeholder="Placeholder"
          />
          <Input
            addonBefore="http://"
            addonAfter=".com"
            disabled
            placeholder="Placeholder"
          />
        </Space>
        <Space>
          <P1>Addon Dropdown</P1>
          <Input
            addonBefore={selectBefore}
            addonAfter={selectAfter}
            placeholder="Placeholder"
          />
          <Input
            addonBefore={selectBefore}
            addonAfter={selectAfter}
            status={"error"}
            placeholder="Placeholder"
          />
          <Input
            addonBefore={selectBefore}
            addonAfter={selectAfter}
            disabled
            placeholder="Placeholder"
          />
        </Space>
        <Space>
          <P1>Number</P1>
          <InputNumber controls={true} min={0} max={10} />
          <InputNumber controls={true} min={0} max={10} status={"error"} />
          <InputNumber controls={true} min={0} max={10} disabled />
        </Space>
        <Space>
          <P1>Date Picker PC</P1>
          <DatePicker />
          <DatePicker showTime />
          <DatePicker disabled />
          <DatePicker disabled showTime />
        </Space>
        <Space>
          <P1> Select </P1>
          <Select
            defaultValue="lucy"
            style={{ width: 120 }}
            options={[
              { value: "jack", label: "Jack" },
              { value: "lucy", label: "Lucy" },
              { value: "Yiminghe", label: "yiminghe" },
              { value: "disabled", label: "Disabled", disabled: true },
            ]}
          />
          <Select
            defaultValue="lucy"
            style={{ width: 120 }}
            disabled
            options={[{ value: "lucy", label: "Lucy" }]}
          />
          <Select
            defaultValue="lucy"
            style={{ width: 120 }}
            loading
            options={[{ value: "lucy", label: "Lucy" }]}
          />
          <Select
            defaultValue="lucy"
            style={{ width: 120 }}
            allowClear
            options={[{ value: "lucy", label: "Lucy" }]}
            placeholder="select it"
          />
          <Select
            defaultValue="lucy"
            style={{ width: 120 }}
            status={"error"}
            options={[{ value: "lucy", label: "Lucy" }]}
            placeholder="select it"
          />
        </Space>
        <Space align="start">
          <P1>Labeled Form</P1>
          <Form requiredMark={false} form={form} layout={"vertical"}>
            <Form.Item name={"default"} label="Default">
              <Input placeholder="Placeholder" />
            </Form.Item>
            <Form.Item
              name={"error"}
              label="Error"
              rules={[{ required: true, message: "Required" }]}
            >
              <Input placeholder="Placeholder" />
            </Form.Item>
            <Form.Item label="Disabled" name={"disabled"}>
              <Input disabled placeholder="Placeholder" />
            </Form.Item>
          </Form>
        </Space>
      </Flex>
      <Divider />
      <Flex gap={"small"} vertical>
        <Space>
          <P1>Default Style</P1>
          <Button> Default Button </Button>
          <Button type={"primary"}> Primary Button </Button>
          <Button type={"dashed"}> Dashed Button </Button>
          <Button type={"link"}> Link Button </Button>
          <Button type={"text"}> Text Button </Button>
        </Space>
        <Space>
          <P1>Ghost Style</P1>
          <Button ghost> Default Button </Button>
          <Button ghost type={"primary"}>
            Primary Button
          </Button>
          <Button ghost type={"dashed"}>
            Dashed Button
          </Button>
          <Button ghost type={"link"}>
            Link Button
          </Button>
          <Button ghost type={"text"}>
            Text Button
          </Button>
        </Space>
        <Space>
          <P1>Disabled Style</P1>
          <Button disabled> Default Button </Button>
          <Button disabled type={"primary"}>
            Primary Button
          </Button>
          <Button disabled type={"dashed"}>
            Dashed Button
          </Button>
          <Button disabled type={"link"}>
            Link Button
          </Button>
          <Button disabled type={"text"}>
            Text Button
          </Button>
        </Space>
        <Space>
          <P1>Loading Style</P1>
          <Button loading> Default Button </Button>
          <Button loading type={"primary"}>
            Primary Button
          </Button>
          <Button loading type={"dashed"}>
            Dashed Button
          </Button>
          <Button loading type={"link"}>
            Link Button
          </Button>
          <Button loading type={"text"}>
            Text Button
          </Button>
        </Space>
        <Space>
          <P1>Danger Style</P1>
          <Button danger> Default Button </Button>
          <Button danger type={"primary"}>
            Primary Button
          </Button>
          <Button danger type={"dashed"}>
            Dashed Button
          </Button>
          <Button danger type={"link"}>
            Link Button
          </Button>
          <Button danger type={"text"}>
            Text Button
          </Button>
        </Space>
        <Space>
          <P1>Size </P1>
          <Button type={"primary"} size={"large"}>
            Large Button
          </Button>
          <Button type={"primary"} size={"middle"}>
            Middle Button
          </Button>
          <Button type={"primary"} size={"small"}>
            Small Button
          </Button>
        </Space>
        <Space>
          <P1>Icon </P1>
          <Button type="primary" icon={<SearchOutlined />} />
          <Button type="primary" size="large" icon={<SearchOutlined />} />
          <Button type="primary" size="small" icon={<SearchOutlined />} />
          <Button type="primary" icon={<SearchOutlined />}>
            Search
          </Button>
          <Button icon={<SearchOutlined />}>Search</Button>
        </Space>
        <P1>Block Style (FullWidth)</P1>
        <Button block> Default Button </Button>
        <Button block type={"primary"}>
          Primary Button
        </Button>
        <Button block type={"dashed"}>
          Dashed Button
        </Button>
        <Button block type={"link"}>
          Link Button
        </Button>
        <Button block type={"text"}>
          Text Button
        </Button>

        <Button type="primary" block icon={<SearchOutlined />} />
      </Flex>
      <Divider />
      <Flex gap={"small"} vertical>
        <Input placeholder="Basic Usage" />
      </Flex>
      <Divider />
      <H1 weight={"heavy"}>
        The lazy bouncing husky 我是哈士奇私はハスキーです
      </H1>
      <H1 weight={"medium"}>
        The lazy bouncing husky 我是哈士奇私はハスキーです
      </H1>
      <H1 weight={"normal"}>
        The lazy bouncing husky 我是哈士奇私はハスキーです
      </H1>

      <Divider />
      <H2 weight={"heavy"}>
        The lazy bouncing husky 我是哈士奇私はハスキーです
      </H2>
      <H2 weight={"medium"}>
        The lazy bouncing husky 我是哈士奇私はハスキーです
      </H2>
      <H2 weight={"normal"}>
        The lazy bouncing husky 我是哈士奇私はハスキーです
      </H2>

      <Divider />
      <H3 weight={"heavy"}>
        The lazy bouncing husky 我是哈士奇私はハスキーです
      </H3>
      <H3 weight={"medium"}>
        The lazy bouncing husky 我是哈士奇私はハスキーです
      </H3>
      <H3 weight={"normal"}>
        The lazy bouncing husky 我是哈士奇私はハスキーです
      </H3>

      <Divider />
      <H4 weight={"heavy"}>
        The lazy bouncing husky 我是哈士奇私はハスキーです
      </H4>
      <H4 weight={"medium"}>
        The lazy bouncing husky 我是哈士奇私はハスキーです
      </H4>
      <H4 weight={"normal"}>
        The lazy bouncing husky 我是哈士奇私はハスキーです
      </H4>

      <Divider />
      <H5 weight={"heavy"}>
        The lazy bouncing husky 我是哈士奇私はハスキーです
      </H5>
      <H5 weight={"medium"}>
        The lazy bouncing husky 我是哈士奇私はハスキーです
      </H5>
      <H5 weight={"normal"}>
        The lazy bouncing husky 我是哈士奇私はハスキーです
      </H5>

      <Divider />
      <H6 weight={"heavy"}>
        The lazy bouncing husky 我是哈士奇私はハスキーです
      </H6>
      <H6 weight={"medium"}>
        The lazy bouncing husky 我是哈士奇私はハスキーです
      </H6>
      <H6 weight={"normal"}>
        The lazy bouncing husky 我是哈士奇私はハスキーです
      </H6>

      <Divider />
      <P1 weight={"heavy"}>
        The lazy bouncing husky 我是哈士奇私はハスキーです
      </P1>
      <P1 weight={"medium"}>
        The lazy bouncing husky 我是哈士奇私はハスキーです
      </P1>
      <P1 weight={"normal"}>
        The lazy bouncing husky 我是哈士奇私はハスキーです
      </P1>

      <Divider />
      <P2 weight={"heavy"}>
        The lazy bouncing husky 我是哈士奇私はハスキーです
      </P2>
      <P2 weight={"medium"}>
        The lazy bouncing husky 我是哈士奇私はハスキーです
      </P2>
      <P2 weight={"normal"}>
        The lazy bouncing husky 我是哈士奇私はハスキーです
      </P2>

      <Divider />
      <P3 weight={"heavy"}>
        The lazy bouncing husky 我是哈士奇私はハスキーです
      </P3>
      <P3 weight={"medium"}>
        The lazy bouncing husky 我是哈士奇私はハスキーです
      </P3>
      <P3 weight={"normal"}>
        The lazy bouncing husky 我是哈士奇私はハスキーです
      </P3>
    </div>
  );
};

export default Design;
